import CustomButton from "../atoms/custom-button.atom";
import CustomText from "../atoms/custom-text.atom";
import { FaCheck, FaTimes, FaArrowRight, FaArrowLeft } from "react-icons/fa";
import PropTypes from "prop-types";

const StepFormTemplate = ({
  title,
  description,
  currentStep,
  totalSteps,
  submitEnabled = false,
  onSubmit,
  onPrevious,
  onClose,
  children,
  loading = false,
  error = null,
  validationErrors = [],
  CloseIcon = FaTimes,
}) => {
  return (
    <div style={styles.container}>
      <div style={styles.closeIconContainer}>
        <CloseIcon onClick={onClose} style={styles.closeIcon} />
      </div>
      <div style={styles.headercontainer}>
        <CustomText variant="headline2xl">{title}</CustomText>

        {/* Barra de progreso mejorada */}
        <div style={styles.progressContainer}>
          <div style={styles.progressBar}>
            <div
              style={{
                ...styles.progressFill,
                width: `${(currentStep / totalSteps) * 100}%`,
              }}
            />
          </div>
          <CustomText
            variant="bodySmall"
            style={{ color: "#626262", marginTop: "8px" }}
          >
            {`Paso ${currentStep} de ${totalSteps}`}
          </CustomText>
        </div>

        <CustomText variant="body">{description}</CustomText>
      </div>

      {/* Mostrar errores de validación */}
      {validationErrors.length > 0 && (
        <div style={styles.errorContainer}>
          <CustomText variant="bodySmall" style={styles.errorText}>
            Errores de validación:
          </CustomText>
          {validationErrors.map((error, index) => (
            <CustomText
              key={index}
              variant="bodySmall"
              style={styles.errorText}
            >
              • {error}
            </CustomText>
          ))}
        </div>
      )}

      {/* Mostrar error general */}
      {error && (
        <div style={styles.errorContainer}>
          <CustomText variant="bodySmall" style={styles.errorText}>
            Error: {error}
          </CustomText>
        </div>
      )}

      <div style={styles.contentContainer}>{children}</div>
      <div style={{ display: "flex", flexGrow: 1 }} />

      {/* Botones de navegación */}
      <div style={styles.buttonContainer}>
        {currentStep > 1 && onPrevious && (
          <CustomButton
            variant="outline"
            onClick={onPrevious}
            left={() => <FaArrowLeft />}
            style={{ flex: 1, marginRight: "8px" }}
          >
            Anterior
          </CustomButton>
        )}

        <CustomButton
          variant="yellow"
          disabled={!submitEnabled || loading}
          onClick={onSubmit}
          right={() =>
            currentStep === totalSteps ? <FaCheck /> : <FaArrowRight />
          }
          style={{ flex: currentStep > 1 ? 1 : "auto" }}
        >
          {loading
            ? "Enviando..."
            : currentStep === totalSteps
            ? "Solicitar"
            : "Siguiente"}
        </CustomButton>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    width: "100%",
    minHeight: "inherit",
    height: "inherit",
    boxSizing: "border-box",
    padding: "24px 16px 16px 16px",
  },
  headercontainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  closeIconContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    marginBottom: "8px",
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    margin: "16px 0px",
  },
  closeIcon: {
    cursor: "pointer",
    fontSize: "24px",
    color: "#1A1A1A",
  },
  errorContainer: {
    backgroundColor: "#ffebee",
    border: "1px solid #f44336",
    borderRadius: "4px",
    padding: "12px",
    marginBottom: "8px",
  },
  errorText: {
    color: "#d32f2f",
    marginBottom: "4px",
  },
  buttonContainer: {
    display: "flex",
    gap: "8px",
    width: "100%",
  },
  progressContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "8px",
  },
  progressBar: {
    width: "100%",
    height: "8px",
    backgroundColor: "#f0f0f0",
    borderRadius: "4px",
    overflow: "hidden",
  },
  progressFill: {
    height: "100%",
    backgroundColor: "#FACE07",
    borderRadius: "4px",
    transition: "width 0.3s ease",
  },
};

StepFormTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  onPrevious: PropTypes.func,
  submitEnabled: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.string,
  validationErrors: PropTypes.arrayOf(PropTypes.string),
  CloseIcon: PropTypes.elementType,
};

export default StepFormTemplate;
